/**
 * @generated SignedSource<<99651289b59a4726e5bf8adc662a2aea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleItem_onSaleVertical$data = {
  readonly category: string | null;
  readonly displayName: string | null;
  readonly firstItemPhotoWebPath: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly " $fragmentType": "HpSharedFeaturedModuleItem_onSaleVertical";
};
export type HpSharedFeaturedModuleItem_onSaleVertical$key = {
  readonly " $data"?: HpSharedFeaturedModuleItem_onSaleVertical$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleItem_onSaleVertical">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleItem_onSaleVertical",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "master"
        }
      ],
      "kind": "ScalarField",
      "name": "firstItemPhotoWebPath",
      "storageKey": "firstItemPhotoWebPath(size:\"master\")"
    }
  ],
  "type": "OnSaleVertical",
  "abstractKey": null
};

(node as any).hash = "8873dc8cee99e62e192fcae2ee00e49a";

export default node;
